import { Edit, Trash2 } from 'lucide-react'
import type { Church } from '@/features/churches/types/church'
import type { PermissionHelper } from '@/utils/permissions'
import { Badge } from '@/components/custom/badge'
import { Button } from '@/components/ui/button'

interface ChurchCardProps {
  church: Church
  pastorName?: string
  permissions: PermissionHelper
  onEdit: (churchId: string) => void
  onDelete: (churchId: string) => void
}

export function ChurchCard({
  church,
  pastorName,
  permissions,
  onEdit,
  onDelete,
}: ChurchCardProps) {
  return (
    <div className="border rounded-lg p-4 hover:shadow-md transition-shadow bg-white">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold text-lg">{church.name}</div>
        <Badge color={church.active ? 'green' : 'gray'}>
          {church.active ? 'Active' : 'Inactive'}
        </Badge>
      </div>

      <div className="space-y-2 mb-4">
        <div className="text-sm">
          <span className="font-medium text-gray-600">Location: </span>
          <span>
            {church.address.city}, {church.address.province}
          </span>
        </div>
        <div className="text-sm">
          <span className="font-medium text-gray-600">Pastor: </span>
          <span>{pastorName || 'Not assigned'}</span>
        </div>
        <div className="text-sm">
          <span className="font-medium text-gray-600">Address: </span>
          <span>
            {church.address.street}, {church.address.city},{' '}
            {church.address.province} {church.address.postal}
          </span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-wrap gap-2">
        {permissions.canEditChurch(church._id) && (
          <Button
            variant="outline"
            size="sm"
            className="w-full sm:w-auto"
            onClick={() => onEdit(church._id)}
          >
            <Edit className="h-4 w-4 sm:mr-2" /> Edit
          </Button>
        )}

        {permissions.canDeleteChurch() && (
          <Button
            variant="destructive"
            size="sm"
            className="w-full sm:w-auto"
            onClick={() => onDelete(church._id)}
          >
            <Trash2 className="h-4 w-4 sm:mr-2" /> Delete
          </Button>
        )}
      </div>
    </div>
  )
}
